import request from '@/Network/Requests/request'
import api from '@/Network/Requests/api'
import Service from '@/Network/Services/Service'
import type {
  WebPushToken,
  WebNotification,
  ListWebNotificationsParams,
  ListWebNotificationsResponse,
  NotificationSummaryResponse
} from '@/types/web-notification.types'

export default class WebNotificationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/web-notifications'
  }

  async subscribe(token: string, deviceInfo?: string): Promise<WebPushToken> {
    try {
      const response = (await request.post(this.getCompletePath('/subscribe'), {
        token,
        deviceInfo
      })) as { data: WebPushToken }
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível ativar as notificações neste navegador.')
    }
  }

  async unsubscribe(token: string): Promise<void> {
    try {
      // `api.delete` direto: o DELETE precisa de body (`data`), que o wrapper `request` não envia.
      await api.delete(this.getCompletePath('/subscribe'), { data: { token } })
    } catch (e) {
      throw this.handleError(e, 'Não foi possível desativar as notificações neste navegador.')
    }
  }

  async list(params?: ListWebNotificationsParams): Promise<ListWebNotificationsResponse> {
    try {
      const response = (await request.get(this.getCompletePath(), params)) as {
        data: ListWebNotificationsResponse
      }
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as notificações.')
    }
  }

  async getSummary(): Promise<NotificationSummaryResponse> {
    try {
      const response = (await request.get(this.getCompletePath('/summary'))) as {
        data: NotificationSummaryResponse
      }
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar o resumo das notificações.')
    }
  }

  async markAsRead(id: number): Promise<WebNotification> {
    try {
      const response = (await request.patch(this.getCompletePath(`/${id}/read`), {})) as {
        data: WebNotification
      }
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível marcar a notificação como lida.')
    }
  }

  async markAllAsRead(): Promise<{ message: string }> {
    try {
      const response = (await request.patch(this.getCompletePath('/read-all'), {})) as {
        data: { message: string }
      }
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível marcar todas as notificações como lidas.')
    }
  }
}
